// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HddTwoToneSvg from "@ant-design/icons-svg/es/asn/HddTwoTone";
import AntdIcon from '../components/AntdIcon';

var HddTwoTone = function HddTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: HddTwoToneSvg
  }));
};

HddTwoTone.displayName = 'HddTwoTone';
export default React.forwardRef(HddTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/HddTwoTone.js
// module id = 1297
// module chunks = 0